import React from 'react'
import { NavLink } from 'react-router-dom'
import permission from '../image/permission.webp'

const Varietydetails3 = () => {
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
      <div>
      <NavLink to="https://www.youtube.com/watch?v=q4154HSQ4C8">  <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=q4154HSQ4C8">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={permission} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Documentary
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          BTS Permission to Dance on Stage in the U.S.
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3 mb-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Documentary
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>  November 27, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Runtime: </span>8 hrs 31 mins
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
      </div>
      <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On November 15, 2023 KST, BTS announced the release of a documentary film showcasing the behind scenes making of their 'Permission to Dance on Stage' concert tour in Los Angeles and Las Vegas.  </p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>2021 Tour Dates:
Los Angeles: Nov 27 & 28, Dec 1 & 2 </p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>2022 Tour Dates:
Las Vegas: April 8, 9, 15, 16</p>
  </div>
</div>
    </div>
  )
}

export default Varietydetails3
